import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { TooltipHost, TooltipOverflowMode, DirectionalHint } from '@bingads-webui-react/fabric-control';

import { ProgressBar } from './progress-bar';

const COLOR_HIGHLIGHT_VNEXT = '#107C10';

export const ActionTable = ({
  headers, values, highlights, alignments, columnWidths,
}) => {
  if (!headers || headers.length === 0
    || (values && values.length !== 0 && values[0].length !== headers.length)
    || (highlights && headers.length !== highlights.length)) {
    return null;
  }

  const columnCount = headers.length;
  const columnWidth = `${100 / columnCount}%`;

  const textAlignArr = _.map(headers, (header, headerIndex) => {
    if (alignments && alignments[headerIndex]) {
      return alignments[headerIndex];
    }
    if (headerIndex === 0) {
      return 'left';
    }
    return 'right';
  });

  const columnWidthArr = _.map(headers, (header, headerIndex) => {
    if (columnWidths && columnWidths[headerIndex]) {
      return columnWidths[headerIndex];
    }
    return columnWidth;
  });

  const headerRow = _.map(headers, (header, headerIndex) => {
    const style = {
      width: columnWidthArr[headerIndex],
      textAlign: textAlignArr[headerIndex],
    };
    return (
      <th key={headerIndex} style={style}>
        {header}
      </th>
    );
  });

  const arrowClass = 'iconba large iconba-Trending12';

  const dataSection = _.map(values, (row, rowIndex) => {
    const dataRow = _.map(row, (item, valueIndex) => {
      const style = {
        width: columnWidthArr[valueIndex],
        textAlign: textAlignArr[valueIndex],
      };
      if (highlights && highlights[valueIndex]) {
        style.color = COLOR_HIGHLIGHT_VNEXT;
      }
      let cell;
      if (item && item.useProgressBar) {
        cell = (
          <ProgressBar
            percentValue={item.percentValue}
            label={item.formattedValue}
            useLabelOnTheRight
          />);
      } else if (item && item.nullableArrow) {
        cell = _.isNull(item.value) ?
          (<span className={arrowClass} />) :
          item.value;
      } else if (item && item.enabledToolTip) {
        cell = (
          <span className={item.toolTipClass}>
            <TooltipHost
              content={item.value}
              overflowMode={TooltipOverflowMode.Parent}
              directionalHint={DirectionalHint.rightCenter}
            >
              {item.value}
            </TooltipHost>
          </span>
        );
      } else {
        cell = item;
      }
      return <td key={valueIndex} style={style}>{cell}</td>;
    });

    return (
      <tr key={rowIndex}>
        {dataRow}
      </tr>
    );
  });

  return (
    <div className="action-table">
      <table width="100%">
        <thead>
          <tr>
            {headerRow}
          </tr>
        </thead>
        <tbody>
          {dataSection}
        </tbody>
      </table>
    </div>
  );
};

ActionTable.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.string),
  values: PropTypes.arrayOf(PropTypes.array),
  highlights: PropTypes.arrayOf(PropTypes.bool),
  alignments: PropTypes.arrayOf(PropTypes.string),
  columnWidths: PropTypes.arrayOf(PropTypes.array),
};

ActionTable.defaultProps = {
  columnWidths: null,
  alignments: null,
  headers: undefined,
  values: undefined,
  highlights: undefined,
};
